<template>
  <div>
    <div
      class=" mainLoader" v-if="loading" >
    </div>
    <div class="realbody">
      <div v-if="role == 'engineer'" class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-12 text-left">
            <div
              @click="goBack(role)"
              v-if="this.history > 1"
              class="btn skywhitebtn backbtn mplus2p-r"
            >
              <img
                style="float: left; margin-top: 2px;"
                src="../../../assets/imgs/backarrow.png"
              />{{$t('back_chat_list')}}
            </div>
          </div>
          <div
            class="col-md-12 companyDetail"
            style="margin: 27px"
            @click="companyDetail(companyId)"
          >
            <span>
              <video v-if="companyVideo"  height="125" width="125"  controls autoplay loop>
                <source :src="companyVideo">
              </video>
              <img v-if="companyImg"
                class="small_tip1"
                :src="companyImg"
              />
            </span>
            <span class="mplus2p-m spacing0-4 black targettitle">
              {{companyName}}
            </span>
          </div>
          <!-- <div class="col-md-12" v-if="show_real_name">
              <div>
                 <div class="tech2">
                      <span class="layer2">
                          {{$t('publish_real_name')}}
                      </span>
                 </div>
              </div>
          </div> -->
          <div class="col-md-12">
            <infinite-loading spinner="waveDots" :identifier="infiniteId"
              v-if="enableInfiniteScroll && Allmessages && Allmessages.length>=0"
              :direction="'top'"
              @infinite="nextPage"
            >
              <span slot="no-more">
                {{$t('no_more')}}
              </span>
              <span slot="no-results">
                <span v-if="Allmessages.length <  0">
                  {{$t('no_result')}}
                </span>
              </span>
            </infinite-loading>
            <div
              class="chathistory"
              v-if="Allmessages == ''"
            >
              <div class="alert alert-success text-center">
                <strong>{{$t('err_startConversation')}}</strong>
              </div>
            </div>
            <div
              v-else
              v-for="(sanderMsg,index) of Allmessages"
              :key="index"
            >
              <div
                v-if="sanderMsg.company_id == undefined"
                class="row chathistory"
              >
                <div class="col-md-12 text-right">
                  <span class="chatdate mplus2p-r black spacing1-2"><u>{{sanderMsg.time}}</u></span>
                </div>

                <div class="col-md-2 text-center">
                  <video v-if="sanderMsg.user_video"  height="125" width="125"  controls autoplay loop>
                    <source :src="sanderMsg.user_video">
                  </video>
                  <img v-if="sanderMsg.user_profile"
                    class=" big_tip rounded-circle1"
                    :src="sanderMsg.user_profile"
                  /><br>
                  <p class="m-0">{{sanderMsg.user_name}}</p>
                  <!-- <span class="chosenfile_title2 mplus2p-m spacing1-2 gray">{{sanderMsg.last_name +' '+ sanderMsg.first_name}}</span> -->
                </div>
                <div class="col-md-10 skillsets text-left">
                  <p
                    class="ccontents left mplsu2p-m spacing1-2 black text-justify"
                    v-html="sanderMsg.message"
                    v-linkified
                  >
                  </p>
                </div>
                <div
                  class="col-md-12 skillsets text-right"
                  v-if="sanderMsg.file != null"
                >
                  <a
                    :href="sanderMsg.file"
                    target="blank"
                    :download="sanderMsg.file_name"
                    class="download-file"
                    v-if="sanderMsg.file != null"
                  >
                    <i class="fa fa-download"></i> {{$t('download_attachment_file')}}
                  </a>
                  <span class="chosenfile_title2 mplus2p-m spacing1-2 gray">{{sanderMsg.file_name}}</span>
                </div>
              </div>
              <div
                v-if="sanderMsg.company_id != undefined"
                class="row chathistory"
              >
                <div class="col-md-12 text-left">
                  <span class="chatdate mplus2p-r black spacing1-2"><u>{{sanderMsg.time}}</u></span>
                  <!-- <i class="fa fa-circle blue chatmanstatus" aria-hidden="true"></i> -->
                </div>

                <div class="col-md-10 skillsets">
                  <div
                    class="ccontents left mplsu2p-m spacing1-2 black text-justify"
                    v-html="sanderMsg.message"
                    v-linkified
                  >
                  </div>
                </div>
                <div class="col-md-2 text-center">
                  <video v-if="sanderMsg.user_video"  height="125" width="125"  controls autoplay loop>
                    <source :src="sanderMsg.user_video">
                </video>
                  <img v-if="sanderMsg.user_profile"
                    class=" big_tip rounded-circle"
                    :src="sanderMsg.user_profile"
                  /><br>
                  <p class="mb-0" v-if="show_real_name">{{sanderMsg.real_name}}</p>
                   <span class="chosenfile_title2 mplus2p-m spacing1-2 gray">{{sanderMsg.initials}}</span>
                </div>
                <div
                  class="col-md-12 skillsets text-left"
                  v-if="sanderMsg.file != null"
                >
                  <a
                    :href="sanderMsg.file"
                    target="blank"
                    :download="sanderMsg.file_name"
                    class="download-file"
                  >
                    <i class="fa fa-download"></i> {{$t('download_attachment_file')}}
                  </a>
                  <span class="chosenfile_title2 mplus2p-m spacing1-2 gray">{{sanderMsg.file_name}}</span>
                </div>
              </div>
            </div>
            <form
              name="form"
              @submit.prevent="doSendMsg(group_id)"
            >
              <div class="row chatinputbody">
                <div
                  class="col-md-12 input form-group"
                  :class="{ invalid: $v.message.$error && messageFocus}"
                >
                  <textarea
                    class="chattextarea form-control"
                    name="message"
                    v-model="message"
                    required
                    autofocus
                  >
                            </textarea>
                  <div class="attachement">
                    <label
                      for="file-upload"
                      class="custom-file-upload mplus2p-m blue spacing1-2"
                    >
                      {{$t('Select_file')}}
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      ref="file"
                      v-on:change="fileSelected($event)"
                    />
                    <span class="chosenfile_title2 mplus2p-m spacing1-2 gray">{{fileName}}</span>
                  </div>
                </div>
                <div
                  class="help-block"
                  style="margin-left: 1.3rem!important"
                  v-if="!$v.message.req && messageFocus"
                >{{$t('required_filed')}}</div>
              </div>
              <div class="row thelast">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                  <button
                    type="submit"
                    class="btn bluebtn sendbtn"
                  >{{$t('chat_button')}} <i
                      v-if="buttonLoading"
                      class="fa fa-refresh fa-spin"
                      style="font-size:24px"
                    ></i>
                  </button>
                  <p style="margin-bottom: 1rem;"></p>
                  <div v-if="!show_real_name"  @click="showRealName" class="d-block text-center">
                    <span  class="addlinks mplus2p-m spacing1-2 blue">{{$t('setting_item2_text1')}}
                    </span>
                  </div>
                </div>
                <div class="col-md-3"></div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        v-if="role == 'company_user'"
        class="container"
      >
        <div
          class="row"
          style="margin-top: 40px;"
        >
          <div class="col-md-12 text-left">
            <div
              @click="goBack(role)"
              class="btn skywhitebtn backbtn mplus2p-r"
            >
              <img
                style="float: left; margin-top: 2px;"
                src="../../../assets/imgs/backarrow.png"
              />{{$t('back_chat_list')}}
            </div>
          </div>
          <div
            class="col-md-12 engineerDetail"
            style="margin: 27px 0px;"
            @click="engineerDetail(engineerId)"
          >
            <span>
              <video v-if="engineerVideo"  height="125" width="125"  controls autoplay loop>
                  <source :src="engineerVideo">
                </video>
              <img v-if="engineerImg"
                class="small_tip"
                :src="engineerImg"
              />
            </span>
            <span class="mplus2p-m spacing0-4 black targettitle">
              {{engineerName}}
            </span>
          </div>

          <div class="col-md-12">
            <infinite-loading  spinner="waveDots"
              v-if="enableInfiniteScroll && Allmessages && Allmessages.length >=0"
              :direction="'top'"
              @infinite="nextPage"
            >
              <span slot="no-more">
                {{$t('no_more')}}
              </span>
              <span slot="no-results">
                <span v-if="Allmessages.length <  0">
                  {{$t('no_result')}}
                </span>
              </span>
            </infinite-loading>

            <div
              class="chathistory"
              v-if="Allmessages == ''"
            >
              <div class="alert alert-success text-center">
                <strong>{{$t('err_startConversation')}}</strong>
              </div>
            </div>

            <div
              class="chat-page"
              id="msgContainer"
              v-else
              v-for="(sanderMsg,index) of Allmessages"
              :key="index"
            >
              <div
                v-if="sanderMsg.user_id == receiverId"
                class="row chathistory"
              >
                <div class="col-md-12 text-right">
                  <span class="chatdate mplus2p-r black spacing1-2"><u>{{sanderMsg.time}}</u></span>
                  <!-- <i class="fa fa-circle blue chatmanstatus" aria-hidden="true"></i> -->
                </div>

                <div class="col-md-2 text-center">
                  <video v-if="sanderMsg.user_video"  height="125" width="125"  controls autoplay loop>
                    <source :src="sanderMsg.user_video">
                  </video>
                  <img v-if="sanderMsg.user_profile != ''"
                    class=" big_tip rounded-circle"
                    :src="sanderMsg.user_profile"
                  /><br>
                  <p class="mb-0">{{sanderMsg.real_name}}</p>
                   <span class="chosenfile_title2 mplus2p-m spacing1-2 gray">{{sanderMsg.initials}}</span>
                </div>
                <div class="col-md-10 skillsets text-left">
                  <p
                    class="ccontents left mplsu2p-m spacing1-2 black text-justify"
                    v-html="sanderMsg.message"
                    v-linkified
                  >
                  </p>
                </div>
                <div
                  class="col-md-12 skillsets text-right"
                  v-if="sanderMsg.file != null"
                >
                  <a
                    :href="sanderMsg.file"
                    target="blank"
                    :download="sanderMsg.file_name"
                    class="download-file"
                  >
                    <i class="fa fa-download"></i> {{$t('download_attachment_file')}}
                  </a>
                  <span class="chosenfile_title2 mplus2p-m spacing1-2 gray">{{sanderMsg.file_name}}</span>
                </div>

              </div>
              <div
                v-if="sanderMsg.user_id != receiverId"
                class="row chathistory"
              >
                <div class="col-md-12 text-left">
                  <span class="chatdate mplus2p-r black spacing1-2"><u>{{sanderMsg.time}}</u></span>
                  <!-- <i class="fa fa-circle blue chatmanstatus" aria-hidden="true"></i> -->
                </div>

                <div class="col-md-10 skillsets text-left">
                  <p
                    class="ccontents left mplsu2p-m spacing1-2 black text-justify"
                    v-html="sanderMsg.message"
                    v-linkified
                  >
                  </p>
                </div>
                <div class="col-md-2 text-center">
                  <video v-if="sanderMsg.user_video"  height="125" width="125"  controls autoplay loop>
                    <source :src="sanderMsg.user_video">
                </video>
                  <img v-if="sanderMsg.user_profile"
                    class=" big_tip rounded-circle1"
                    :src="sanderMsg.user_profile"
                  /><br>
                  <p class="m-0">{{sanderMsg.user_name}}</p>
                  <span class="chosenfile_title2 mplus2p-m spacing1-2 gray">{{sanderMsg.last_name +' '+ sanderMsg.first_name}}</span>
                </div>
                <div
                  class="col-md-10 skillsets text-left"
                  v-if="sanderMsg.file != null"
                >
                  <a
                    :href="sanderMsg.file"
                    target="blank"
                    :download="sanderMsg.file_name"
                    class="download-file"
                  >
                    <i class="fa fa-download"></i> {{$t('download_attachment_file')}}
                  </a>
                  <span class="chosenfile_title2 mplus2p-m spacing1-2 gray">{{sanderMsg.file_name}}</span>
                </div>
              </div>
            </div>

            <form
              name="form"
              @submit.prevent="doSendMsg(group_id)"
            >
              <div class="row chatinputbody">
                <div
                  class="col-md-12 input form-group"
                  :class="{ invalid: $v.message.$error && messageFocus}"
                >
                  <textarea
                    class="chattextarea form-control"
                    name="message"
                    v-model="message"
                    autofocus
                  >
                        </textarea>
                  <div class="attachement">
                    <label
                      for="file-upload"
                      class="custom-file-upload mplus2p-m blue spacing1-2"
                    >
                      {{$t('Select_file')}}
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      ref="file"
                      v-on:change="fileSelected($event)"
                    />
                    <span class="chosenfile_title2 mplus2p-m spacing1-2 gray">{{fileName}}</span>
                  </div>
                </div>
                <div
                  class="help-block"
                  style="margin-left: 1.3rem!important"
                  v-if="!$v.message.req && messageFocus"
                >{{$t('required_filed')}}</div>
              </div>
              <div class="row thelast">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                  <button
                    type="submit"
                    id="btn-submit"
                    class="btn bluebtn sendbtn"
                  >{{$t('chat_button')}} <i
                      v-if="buttonLoading"
                      class="fa fa-refresh fa-spin"
                      style="font-size:24px"
                    ></i></button>
                </div>
                <div class="col-md-3"></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  email,
  minLength,
  minValue,
  sameAs
} from "vuelidate/lib/validators";
import Hashids from "hashids";
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import ImageCompressor from "image-compressor.js";
import { EventBus } from "../../../main.js";
var moment = require("moment");
import Swal from 'sweetalert2/dist/sweetalert2.js'
export default {
  components: {
    InfiniteLoading
  },
  mixins: [validationMixin],

  validations: {
    message: { req: required }
  },
  data() {
    return {
      model: {},
      loading: false,
      buttonLoading: false,
      messageFocus: false,
      file: "",
      fileName: "-",

      imgSrc: "",
      img: [],

      page: 0,
      lastPage: 1,
      length: 10,

      lId: "",
      Id: "",
      receiverId: "",
      group_id: "",

      userId: "",
      userName: "",
      userImg: "",
      userVideo: "",
      userToken: "",
      job_seeking: [],

      companyId: 0,
      companyName: "",
      companyImg: "",
      companyVideo: "",
      company_user_last_name: "",
      company_user_first_name: "",

      engineerId: 0,
      engineerName: "",
      engineerImg: "",
      engineerVideo: "",

      message: "",
      popupDisplay: false,

      Allmessages: [],
      real_name: '',
      role: "",
      lan: "jp",
      enableInfiniteScroll: true,

      get_favored_mail: '',
      get_message_mail: '',
      show_real_name: true,
      want_to_talk_casually : false,

      infiniteId: '',

      history: ""
    };
  },
  mounted() {
    if ("user" in localStorage) {
      var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      this.userName = data.last_name + data.first_name;
      this.userId = data.id;
      if (data.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
        this.userVideo = data.image
      }else{
        this.userImg = data.image;
      }
      this.role = localStorage.getItem("role");
      this.userToken = data.user_token;
      this.job_seeking = data.job_seeking_situation;
      this.get_favored_mail = data.get_favored_mail;
      this.get_message_mail = data.get_message_mail;
      if (data.publish_real_name != undefined || data.publish_real_name != '') {
          this.show_real_name = data.publish_real_name
      }
      if (data.want_to_talk_casually) {
        this.want_to_talk_casually = data.want_to_talk_casually;
      }
    }
    EventBus.$on("language", data => {
      this.lan = data;
    });
    var hashids = new Hashids(
      "this is my salt",
      8,
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
    );
    var group_id = hashids.decode(this.$route.params.id);
    this.receiverId = group_id;

    if (group_id.length == 0) {
      return this.$router.push("/global/PageNotFound");
    }
    if (this.role == "engineer") {
      this.getCompany(this.receiverId);
      // this.getMessages(this.receiverId);
    } else {
      var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      this.companyId = data.company.id;
      this.company_user_last_name = data.last_name;
      this.company_user_first_name = data.first_name;
      this.companyName = data.company.name;
      if (data.company.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
        this.companyVideo = data.company.image;
      }else{
        this.companyImg = data.company.image;
      }
      this.getEngineer(this.receiverId);
      // this.getMessages(this.receiverId);
    }
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    this.history = window.history.length;
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString().split(" ");
      return value.map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(" ");
    }
  },
  methods: {
    showRealName(){
        this.loading = true;
        var token = localStorage.getItem("token");

        const formData = {
            get_favored_mail: this.get_favored_mail,
            get_message_mail: this.get_message_mail,
            publish_real_name: true,
            want_to_talk_casually: this.want_to_talk_casually
        };
        axios
            .post("/mail-settings?token="+token, formData ,{
            headers: { "X-localization": localStorage.getItem("lan") }
            })
            .then(res => {
            if (!res.data.result) {
                if (res.data[0]) {
                this.$toaster.error(res.data[0]);
                this.$store.dispatch("logout");
                }
                this.loading = false;
            } else {
                this.loading = false;
                this.get_favored_mail = res.data.get_favored_mail;
                this.get_message_mail = res.data.get_message_mail;
                this.show_real_name = res.data.publish_real_name;
                this.want_to_talk_casually = res.data.want_to_talk_casually;
                var user = JSON.parse(localStorage.getItem("user"))
                user.get_favored_mail = this.get_favored_mail;
                user.get_message_mail = this.get_message_mail;
                user.publish_real_name = this.show_real_name;
                user.want_to_talk_casually = this.want_to_talk_casually;
                localStorage.setItem("user", JSON.stringify(user));
                $('html, body').animate({scrollTop:0}, 'faster');
                this.Allmessages = [];
                this.infiniteId = 1;
            }
            })
            .catch(error => console.log(error));
    },
    engineerDetail(eid) {
      var hashids = new Hashids(
        "EngineerIds",
        8,
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
      );
      let routeData = this.$router.resolve({
        name: "companyEngineerDetail",
        params: { uid: hashids.encode(eid) }
      });
      window.open(routeData.href, "_blank");
    },
    companyDetail(cid) {
      var hashids = new Hashids(
        "CompanyIds",
        8,
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
      );
      let routeData = this.$router.resolve({
        name: "companyDetail",
        params: { cid: hashids.encode(cid) }
      });
      window.open(routeData.href, "_blank");
    },
    nextPage($state) {
      if (this.infiniteId === 1) {
        this.page = 1
        if (this.role == "engineer") {
          this.getMessages(this.receiverId, $state);
        }
        if (this.role == "company_user") {
          this.getMessages(this.receiverId, $state);
        }
      }
      else{
        this.page++;
        if (this.role == "engineer") {
        this.getMessages(this.receiverId, $state);
        }
        if (this.role == "company_user") {
          this.getMessages(this.receiverId, $state);
        }
      }

    },
    readUrl(e) {
      this.imgSrc = e.target.files[0];
    },
    fileSelected(event) {
      this.fileName = event.target.files[0]
        ? event.target.files[0].name
        : this.fileName;
      var file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      let self = this;

      if (
        this.$refs.file.files[0].type == "image/jpg" ||
        this.$refs.file.files[0].type == "image/png" ||
        this.$refs.file.files[0].type == "image/jpeg"
      ) {
        new ImageCompressor(file, {
          quality: 0.6,
          success(result) {
            self.file = result;
          },
          error(e) {
            console.log(e.message);
          }
        });
      } else {
        self.file = this.$refs.file.files[0];
      }
    },
    doSendMsg(receiver_id) {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.messageFocus = true;
      } else {
        if (this.popupDisplay) {
          this.loading = true;
          let formData = new FormData();
          formData.append("group_id", this.group_id);
          formData.append("message", this.message);
          if (this.file) {
            formData.append("file", this.file, this.fileName);
          }

          axios
            .post(
              "/chatroom?token=" + localStorage.getItem("token"),
              formData,
              {
                headers: {
                  "X-localization": localStorage.getItem("lan"),
                  "Content-Type": "multipart/form-data"
                }
              }
            )
            .then(res => {
              if (!res.data.result) {
                if (res.data[0]) {
                  this.$toaster.error(res.data[0]);
                  this.$store.dispatch("logout");
                }
                if (res.data.errors) {
                  for (var i = 0; i < res.data.errors.length; i++) {
                    if (res.data.errors[i].message) {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                  }
                }
                this.loading = false;
              } else {
                if (this.show_real_name) {
                  var data = JSON.parse(localStorage.getItem("user"));
                  this.real_name = data.last_name + data.first_name  
                }
                if (this.role == "engineer") {
                  this.Allmessages.push({
                    id: 0,
                    user_id: this.userId,
                    company_id: 1,
                    group_id: this.group_id,
                    message: res.data.data.message,
                    receiver_status: 0,
                    real_name: this.real_name,
                    time: res.data.data.time,
                    file: res.data.data.file,
                    user_name: this.userName,
                    user_profile: this.userImg ? this.userImg : '',
                    user_video: this.userVideo ? this.userVideo : '',
                    file_name: res.data.data.file_name
                  });
                  this.loading = false;
                }
                if (this.role == "company_user") {

                  this.Allmessages.push({
                    id: 0,
                    user_id: this.userId,
                    group_id: this.group_id,
                    message: res.data.data.message,
                    receiver_status: 0,
                    last_name: this.company_user_last_name,
                    first_name: this.company_user_first_name,
                    file: res.data.data.file,
                    user_name: this.companyName,
                    user_profile: this.userImg ? this.userImg : '',
                    user_video: this.userVideo ? this.userVideo : '',
                    time: res.data.data.time,
                    file_name: res.data.data.file_name
                  });
                  this.loading = false;
                }
              }
              this.message = "";
              this.file = "";
              this.fileName = "";
            })
            .catch(error => console.log(error));

          var vm = this;
          const swalWithBootstrapButtons = Swal.mixin({
            confirmButtonClass: "btn btn-primary inquiry",
            cancelButtonClass: "btn btn-success change",
            buttonsStyling: false
          });

          swalWithBootstrapButtons({
            html:
              vm.$t("pop_up_title") +' <b style="color:black;font-weight:700">' +
            (!this.job_seeking ? vm.$t('pop_up_unselected') :
            (this.lan == "en"
              ? this.job_seeking.en_situation
              : this.job_seeking.jp_situation)) +
            "</b>. " +
            '<span style="font-size: 16px !important">'+vm.$t("pop_up_it_ok")+'</span>',
            type: "info",
            showCancelButton: true,
            showConfirmButton: this.job_seeking ? true : false,
            confirmButtonText: vm.$t("pop_up_ok"),
            cancelButtonText: vm.$t("pop_up_change"),
            reverseButtons: false,
            allowOutsideClick: false
          }).then(result => {
            if (result.value) {
              axios
                .post("/popup-display?token=" + localStorage.getItem("token"), {
                  headers: { "X-localization": localStorage.getItem("lan") }
                })
                .then(res => {
                  this.popupDisplay = false;
                })
                .catch(error => console.log(error));
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              axios
                .post("/popup-display?token=" + localStorage.getItem("token"), {
                  headers: { "X-localization": localStorage.getItem("lan") }
                })
                .then(res => {
                  this.popupDisplay = false;
                  vm.$router.push({
                    name: "engineerProfileEdit",
                    params: { uid: this.userToken },
                    query: { page: 1 }
                  });
                })
                .catch(error => console.log(error));
            }
          });
        } else {
          this.loading = true;
          let formData = new FormData();
          formData.append("group_id", this.group_id);
          formData.append("message", this.message);
          if (this.file) {
            formData.append("file", this.file, this.fileName);
          }
          axios
            .post(
              "/chatroom?token=" + localStorage.getItem("token"),
              formData,
              {
                headers: {
                  "X-localization": localStorage.getItem("lan"),
                  "Content-Type": "multipart/form-data"
                }
              }
            )
            .then(res => {
              if (!res.data.result) {
                if (res.data[0]) {
                  this.$toaster.error(res.data[0]);
                  this.$store.dispatch("logout");
                }
                if (res.data.errors) {
                  for (var i = 0; i < res.data.errors.length; i++) {
                    if (res.data.errors[i].message) {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                  }
                }
                this.loading = false;
              } else {
                if (this.show_real_name) {
                  var data = JSON.parse(localStorage.getItem("user"));
                  this.real_name =  data.last_name + data.first_name
                }
                if (this.role == "engineer") {
                  this.Allmessages.push({
                    id: 0,
                    user_id: this.userId,
                    company_id: 1,
                    group_id: this.group_id,
                    message: res.data.data.message,
                    receiver_status: 0,
                    time: res.data.data.time,
                    file: res.data.data.file,
                    user_name: this.userName,
                    real_name: this.real_name,
                    user_profile: this.userImg ? this.userImg : '',
                    user_video: this.userVideo ? this.userVideo : '',
                    file_name: res.data.data.file_name
                  });
                  this.loading = false;
                }
                if (this.role == "company_user") {
                  this.Allmessages.push({
                    id: 0,
                    user_id: this.userId,
                    group_id: this.group_id,
                    message: res.data.data.message,
                    receiver_status: 0,
                    last_name: this.company_user_last_name,
                    first_name: this.company_user_first_name,
                    file: res.data.data.file,
                    user_name: this.companyName,
                    user_profile: this.userImg ? this.userImg : '',
                    user_video: this.userVideo ? this.userVideo : '',
                    time: res.data.data.time,
                    file_name: res.data.data.file_name
                  });
                  this.loading = false;
                }
              }
              this.message = "";
              this.file = "";
              this.fileName = "";
            })
            .catch(error => console.log(error));
        }
      }
    },

    getCompany(cid) {
      axios
        .get("/company/" + cid + "?token=" + localStorage.getItem("token"), {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
          } else {
            this.companyId = res.data.company.id;
            this.companyName = res.data.company.name;
            if (res.data.company.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
              this.companyVideo = res.data.company.image
            }else{
              this.companyImg = res.data.company.image;
            }
          }
        })
        .catch(error => console.log(error));
    },
    getEngineer(eid) {
      axios
        .get("/user/" + eid + "?token=" + localStorage.getItem("token"), {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (res.data[0]) {
            this.$toaster.error(res.data[0]);
            this.$store.dispatch("logout");
          }
          if (!res.data.result) {
          } else {
            this.engineerName = res.data.user.initials;
            this.engineerId = res.data.user.id;
            if (res.data.user.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
              this.engineerVideo = res.data.user.image
            }else{
              this.engineerImg = res.data.user.image;
            }
          }
        })
        .catch(error => console.log(error));
    },
    goBack(role) {
      if (role == "engineer") {
        this.$router.push("/engineer/chataction-list");
      } else {
        this.$router.push("/company/chataction-list");
      }
    },
    getMessages(id, $state) {
      let self = this;
      self.$state = $state;
      axios
        .get(
          "/conversations/" +
            id +
            "?page=" +
            this.page +
            "&token=" +
            localStorage.getItem("token"),
          { headers: { "X-localization": localStorage.getItem("lan") } }
        )
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            if (res.data.errors) {
              for (var i = 0; i < res.data.errors.length; i++) {
                if (res.data.errors[i].message) {
                  this.$toaster.error(res.data.errors[i].message);
                  this.$router.replace("/global/PageNotFound");
                  self.$state.complete();
                }
              }
            }
          } else {
            for (let index = 0; index < res.data.messages.data.length; index++) {
              if (res.data.messages.data[index].user_profile) {
                 if (res.data.messages.data[index].user_profile.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
                res.data.messages.data[index].user_video = res.data.messages.data[index].user_profile
                  res.data.messages.data[index].user_profile = ""
                }else{
                  res.data.messages.data[index].user_profile = res.data.messages.data[index].user_profile
                  res.data.messages.data[index].user_video = ""
                }
              }
            }
            this.popupDisplay = res.data.popup_display;
            if (this.Allmessages.length > 0) {
              this.Allmessages = res.data.messages.data
                .reverse()
                .concat(this.Allmessages);
              this.lastPage = res.data.messages.last_page;
              window.scrollTo(0, 150 * res.data.messages.data.length);
              setTimeout(() => {
                if (res.data.messages.data.length) {
                  self.$state.loaded();
                } else {
                  self.$state.complete();
                }
              }, 1000);
            } else {

              this.Allmessages = res.data.messages.data.reverse();
              setTimeout(() => {
                window.scrollTo(0, document.body.scrollHeight - 800);
              }, 500);
              if (self.$state) {
                self.$state.complete();
              }
            }
            setTimeout(() => {
              if (res.data.messages.data.length > 0) {
                this.enableInfiniteScroll = true;
              }
            }, 1500);
            this.group_id = res.data.group_id;
          }
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style scoped>
.tech2 {
  margin-right: 5px;
  margin-bottom: 10px;
}
.layer2 {
  width: fit-content;
  background-color: #3d7dd8;
  font-size: 1rem;
  text-align: center;
  font-family: mplus2-m;
  font-weight: 400;
  letter-spacing: 1.2px;
  color: #fff;
  padding: 8px;
  margin-right: 5px;
  margin-bottom: 20px;
  border-radius: 15px;
  display: block;
}
.engineerDetail {
  cursor: pointer;
}
.companyDetail {
  cursor: pointer;
}
.rounded-circle1 {
  margin-top: 15px;
  border-radius: 100%;
}
.download-file {
  font-size: 13px;
}
.rounded-circle {
  margin-top: 15px;
  border-radius: 100%;
}
.left {
  margin-top: 15px !important;
  border-radius: 3.2px;
  background-color: rgba(61, 125, 216, 0.08);
  /* color: #3d7dd8; */
  font-size: 1em;
  font-weight: 500;
  padding: 4px 8px;
  margin-left: 5px;
  float: left;
  cursor: pointer;
}

.right {
  margin-top: 15px !important;
  border-radius: 3.2px;
  background-color: rgba(61, 125, 216, 0.08);
  color: #3d7dd8;
  font-size: 1em;
  font-weight: 500;
  padding: 4px 8px;
  margin-left: 5px;
  float: right;
  cursor: pointer;
}

.backbtn {
  width: 240px;
  height: 48px;
  border-radius: 8px;
  margin-top: 50px;
  padding-top: 13px;

  font-size: 1rem;
  font-weight: bold;
}

.chattitle {
  font-size: 1.5rem;
  font-weight: 500;
  margin-top: 42px;
}

.chathistory {
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(60, 80, 100, 0.12);
  background-color: #ffffff;
  border: solid 1px #e8eaee;

  padding: 10px 5px;
  margin: 0;
  margin-bottom: 18px;
}

.small_tip {
  width: 100px;
  height: 100px;
  object-position: center;
  border-radius: 100%;
}
.small_tip1 {
  width: 125px;
  height: 125px;
  object-position: center;
}

.big_tip {
  width: 125px;
  height: 125px;
}

.targettitle {
  position: absolute;
  font-size: 0.875rem;
  font-weight: 500;
  margin-left: 10px;
  margin-top: 50px;
}
.ccontents {
  word-break: break-all;
}
.chatdate {
  font-size: 0.75rem;
}

.chatmanstatus {
  font-size: 0.625rem;
  margin-left: 4px;
}

.chatmantitle {
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: underline;
}

.chatmancontents {
  font-size: 1rem;
  font-weight: 500;
  line-height: 2;
  margin-top: 10px;
}

.chattextarea {
  border-radius: 4px;
  background-color: #f0f2f4;
  border: solid 1px #e6e8ea;
  width: 100%;
  height: 140px;
}

.chatinputbody {
  margin-top: 40px;
}

.attachement {
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 2px #e6e8ea;
  width: 100%;
  margin-top: -7px;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 8px;
}

.chosenfile_title {
  font-size: 0.875rem;
  font-weight: 500;
}
.chosenfile_title2 {
  font-size: 0.675rem;
  font-weight: 500;
}
 .input.invalid label {
    color: red;
  }

  .input.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }
  .input.invalid select{
    border: 1px solid red;
    background-color: #ffc9aa;
  }
  .input.invalid textarea{
    border: 1px solid red !important;
    background-color: #ffc9aa !important;
  }
.thelast {
  margin-top: 30px;
}

.sendbtn {
  width: 100%;
  height: 56px;
}

@media screen and (max-width: 992px) {
  .chatbody {
    padding: 0px 40px;
  }
}

@media screen and (max-width: 768px) {
  .chatbody {
    padding: 10px 15px;
  }

  .chosenfile_title {
    margin-left: 15px;
  }
}
</style>
